import { createSelector } from '@reduxjs/toolkit';
import selectStreams from './selectStreams';

export default createSelector(selectStreams, (streams) => Object.values(streams?.list ?? {}));
